<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
      lazy
      :fullscreen="$vuetify.breakpoint.xs"
      hide-overlay
      scrollable
  >
      <v-tooltip bottom slot="activator">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                color='primary'
                v-bind="attrs"
                v-on="on"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </template>
        <h3>Cadastrar Novo Cliente</h3>
      </v-tooltip>

      <CardCadastroCliente @fechar="dialog = false" @cadastroRealizado="dialog = false, this.$emit('cadastroRealizado')"/>
  </v-dialog>
</template>

<script>
import CardCadastroCliente from '@/components/CardCadastroCliente.vue'

export default {
  components: {
    CardCadastroCliente
  },
  data: () => ({
    dialog: false
  })
}
</script>

<style scoped>
.headline {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 16px 24px;
}
</style>
